import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/trainer-profiles', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/trainer-profiles', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
    return httpClient
        .put(`/api/trainer-profiles/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
    return httpClient
        .delete(`/api/trainer-profiles/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const formModel = (options = {}) => {
    return httpClient
        .get('/api/trainer-profiles/form-view-models', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const photoUpload = data => {
    return httpClient
        .post('/api/trainer-profiles/upload-photos', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default { get, store, update, destroy, formModel, photoUpload }

